var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcPersoW(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36.73 36.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_358",
    "data-name": "Groupe 358"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_344",
    "data-name": "Groupe 344"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3989",
    "data-name": "Trac\\xE9 3989",
    d: "M18.36,36.73A18.37,18.37,0,1,1,36.73,18.36h0A18.39,18.39,0,0,1,18.36,36.73Zm0-35.58A17.22,17.22,0,1,0,35.58,18.37,17.22,17.22,0,0,0,18.36,1.15Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_345",
    "data-name": "Groupe 345"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3990",
    "data-name": "Trac\\xE9 3990",
    d: "M28.12,28.12h-.07c-.93-.11-5.63-.7-6.68-1.92-.65-.76-.3-2.61-.12-3.37a.59.59,0,0,1,.3-.39c.88-.44,1.7-2.39,2-3.63.22-.92.39-2.43.52-3.54l.05-.41a9.6,9.6,0,0,0,0-2.73C23.79,9.8,21.32,8,18.36,8s-5.43,1.76-5.74,4.09a9.6,9.6,0,0,0,0,2.73l.05.41c.12,1.11.3,2.62.51,3.54.3,1.24,1.11,3.19,2,3.63a.58.58,0,0,1,.31.39c.18.76.52,2.61-.13,3.37-1,1.21-5.75,1.81-6.68,1.92A.57.57,0,1,1,8.54,27c2.13-.25,5.39-.88,5.94-1.53a4.35,4.35,0,0,0-.07-2.12c-1.25-.85-2.08-3.11-2.35-4.26s-.42-2.44-.54-3.67l0-.41a10.84,10.84,0,0,1,0-3c.39-2.9,3.35-5.09,6.88-5.09S24.85,9.08,25.24,12a10.84,10.84,0,0,1,0,3l0,.41a34.87,34.87,0,0,1-.53,3.67c-.28,1.15-1.1,3.4-2.35,4.25a4.39,4.39,0,0,0-.07,2.13c.55.65,3.8,1.28,5.94,1.53a.57.57,0,0,1-.07,1.14Z",
    style: {
      fill: "#fff"
    }
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPersoW);
export default __webpack_public_path__ + "static/media/ic-perso-w.a1074d6b45b4c1ff7955297fa323321f.svg";
export { ForwardRef as ReactComponent };